import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/no.png'


const _withScopeId = n => (_pushScopeId("data-v-34a79c50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mainBody" }
const _hoisted_2 = { class: "carInfo" }
const _hoisted_3 = { class: "iccid" }
const _hoisted_4 = { class: "carNum" }
const _hoisted_5 = { class: "carState" }
const _hoisted_6 = { class: "optionDate" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "left" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "titleDetailsWrap" }
const _hoisted_11 = { class: "titleDetails" }
const _hoisted_12 = { class: "packageSize" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "流量", -1))
const _hoisted_14 = { class: "titleDetails" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "有效期", -1))
const _hoisted_16 = { class: "right_price" }
const _hoisted_17 = { class: "priceNum" }
const _hoisted_18 = { class: "priceInfo" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "left" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "titleDetailsWrap" }
const _hoisted_23 = { class: "titleDetails" }
const _hoisted_24 = { class: "packageSize" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "流量", -1))
const _hoisted_26 = { class: "titleDetails" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "有效期", -1))
const _hoisted_28 = { class: "right_price" }
const _hoisted_29 = { class: "priceNum" }
const _hoisted_30 = { class: "priceInfo" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "left" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "titleDetailsWrap" }
const _hoisted_35 = { class: "titleDetails" }
const _hoisted_36 = { class: "packageSize" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "流量", -1))
const _hoisted_38 = { class: "titleDetails" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "有效期", -1))
const _hoisted_40 = { class: "right_price" }
const _hoisted_41 = { class: "priceNum" }
const _hoisted_42 = { class: "priceInfo" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = { class: "left" }
const _hoisted_45 = { class: "title" }
const _hoisted_46 = { class: "titleDetailsWrap" }
const _hoisted_47 = { class: "titleDetails" }
const _hoisted_48 = { class: "packageSize" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "流量", -1))
const _hoisted_50 = { class: "titleDetails" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "有效期", -1))
const _hoisted_52 = { class: "right_price" }
const _hoisted_53 = { class: "priceNum" }
const _hoisted_54 = { class: "priceInfo" }
const _hoisted_55 = ["onClick"]
const _hoisted_56 = { class: "left" }
const _hoisted_57 = { class: "title" }
const _hoisted_58 = { class: "titleDetailsWrap" }
const _hoisted_59 = { class: "titleDetails" }
const _hoisted_60 = { class: "packageSize" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "流量", -1))
const _hoisted_62 = { class: "titleDetails" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "有效期", -1))
const _hoisted_64 = { class: "right_price" }
const _hoisted_65 = { class: "priceNum" }
const _hoisted_66 = { class: "priceInfo" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "left" }
const _hoisted_69 = { class: "title" }
const _hoisted_70 = { class: "titleDetailsWrap" }
const _hoisted_71 = { class: "titleDetails" }
const _hoisted_72 = { class: "packageSize" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "流量", -1))
const _hoisted_74 = { class: "titleDetails" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p1" }, "有效期", -1))
const _hoisted_76 = { class: "right_price" }
const _hoisted_77 = { class: "priceNum" }
const _hoisted_78 = { class: "priceInfo" }
const _hoisted_79 = {
  key: 0,
  style: {"width":"100%","text-align":"center"}
}
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "暂无套餐数据", -1))
const _hoisted_82 = [
  _hoisted_80,
  _hoisted_81
]
const _hoisted_83 = { class: "ConfirmationPurchase" }
const _hoisted_84 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "请确认购买套餐", -1))
const _hoisted_85 = { class: "carNum" }
const _hoisted_86 = { class: "iccid" }
const _hoisted_87 = { class: "packageName" }
const _hoisted_88 = {
  class: "price",
  style: {"margin-bottom":"20px"}
}
const _hoisted_89 = { class: "ConfirmationPurchase" }
const _hoisted_90 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header" }, "支付", -1))
const _hoisted_91 = { style: {"display":"flex","justify-content":"space-between","margin-top":"20px"} }

import {
  getAgainOrder,
  getAgentPackageList,
  getCloseAgainOrder,
  postOrderPackage,
} from "@/api";
import router from "@/router";
import { useRoute } from "vue-router";
import { ref } from "vue";
import { showDialog, showToast } from "vant";
import { setWxConfig } from "@/utils";
import wx from "weixin-js-sdk-ts";


export default /*#__PURE__*/_defineComponent({
  __name: 'purchasePackage',
  setup(__props) {

const activeName = ref("30");
const route = useRoute();
let purchaseShow = ref(false);
let againPurchaseShow = ref(false); /* 二次支付弹窗 */
let carInfo = ref<any>({
  iccid: "",
  phone: "",
  cardStatus: "",
});
let selectPackageIndex = ref(); /* 选中的套餐序号 */
let selectPackageItem = ref(); /* 选中的套餐内容 */
let packageList = ref();
let againPackageName = ref(); /* 二次支付的套餐名 */
let againOrderNo = ref(); /* 二次支付的订单号 */
//获取套餐列表
function _getAgentPackageList(val = "30") {
  console.log(route.query);
  carInfo.value = route.query;
  let params = {
    iccid: route.query.iccid,
    dayCode: val,
  };
  getAgentPackageList(params).then((res: any) => {
    if (res.code == 200) {
      packageList.value = res.result;
    }
  });
  console.log(packageList.value);
}
_getAgentPackageList();

//选择日期，获取套餐列表
function changePackageData() {
  console.log(activeName.value, 1231321);
  selectPackageIndex.value = undefined;
  selectPackageItem.value = undefined;
  _getAgentPackageList(activeName.value);
}
//选中的套餐
function selectPackage(item: any, index: number) {
  selectPackageIndex.value = index;
  selectPackageItem.value = item;
  console.log(selectPackageItem.value, 12313213);
}
//跳转购买须知
function toPurchaseNotes() {
  router.push("/purchaseNotes");
}

//提交订单
function submitOrder() {
  let params = {
    packageId: selectPackageItem.value.packageId,
    appId: sessionStorage.getItem("appId"),
    iccid: route.query.iccid,
    userId: sessionStorage.getItem("userId"),
  };
  postOrderPackage(params).then((res: any) => {
    if (res.code == 200) {
      // const { payInfo } = res.result;
      wx.chooseWXPay({
        // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        timestamp: res.result.payInfo.timeStamp,
        // 支付签名随机串，不长于 32 位
        nonceStr: res.result.payInfo.nonceStr,
        // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        package: res.result.payInfo.package,
        // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        signType: res.result.payInfo.signType,
        // 支付签名
        paySign: res.result.payInfo.paySign,
        appId: res.result.payInfo.appId,
        // 支付成功后的回调函数
        success: function (res) {
          // res.errMsg === 'chooseWXPay:ok'方式判断前端返回,微信团队郑重提示：
          // res.errMsg将在用户支付成功后返回ok，但并不保证它绝对可靠， 切记。
          router.push({
            path: "/purchaseSucceeds",
            query: {
              iccid: route.query.iccid,
            },
          });
        },
      });
    } else {
      if (res.code == 214) {
        againPurchaseShow.value = true;
        againPackageName.value = res.message.split("|")[1];
        againOrderNo.value = res.message.split("|")[0];
      } else {
        showDialog({
          message: res.message,
        }).then(() => {
          // on close
        });
      }
    }
    purchaseShow.value = false;
  });
}
//取消订单弹窗
function cancelOrder() {
  purchaseShow.value = false;
}
//确认提交订单
function toPurchase() {
  console.log(selectPackageItem.value);
  if (selectPackageItem.value == undefined) {
    showToast("请先选择套餐");
    return;
  }
  purchaseShow.value = true;
}
//二次支付
function againSubmitOrder() {
  againPurchaseShow.value = false;
  let params = {
    orderNo: againOrderNo.value,
  };
  getAgainOrder(params).then((res: any) => {
    if (res.code == 200) {
      wx.chooseWXPay({
        // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
        timestamp: res.result.payInfo.timeStamp,
        // 支付签名随机串，不长于 32 位
        nonceStr: res.result.payInfo.nonceStr,
        // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=\*\*\*）
        package: res.result.payInfo.package,
        // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
        signType: res.result.payInfo.signType,
        // 支付签名
        paySign: res.result.payInfo.paySign,
        appId: res.result.payInfo.appId,
        // 支付成功后的回调函数
        success: function (res) {
          // res.errMsg === 'chooseWXPay:ok'方式判断前端返回,微信团队郑重提示：
          // res.errMsg将在用户支付成功后返回ok，但并不保证它绝对可靠， 切记。
          router.push({
            path: "/purchaseSucceeds",
            query: { iccid: route.query.iccid },
          });
        },
      });
    } else {
      showToast(res.message);
    }
  });
}
//取消二次支付
function againCancelOrder() {
  againPurchaseShow.value = false;
  let params = {
    orderNo: againOrderNo.value,
  };
  getCloseAgainOrder(params).then((res: any) => {
    if (res.code == 200) {
      showToast("取消成功");
    } else {
      showToast(res.message);
    }
  });
}
setWxConfig(["chooseWXPay"]);

return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, "ICCID: " + _toDisplayString(_unref(carInfo).iccid), 1),
      _createElementVNode("div", _hoisted_4, "卡号:" + _toDisplayString(_unref(carInfo).phone), 1),
      _createElementVNode("div", _hoisted_5, "卡状态:" + _toDisplayString(_unref(carInfo).cardStatus), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_van_tabs, {
        active: activeName.value,
        "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
        type: "card",
        color: "#FEE6B9",
        "title-active-color": "black",
        onChange: changePackageData
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_tab, {
            title: "30天",
            name: "30"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packageList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: "packageItem",
                  class: _normalizeClass({ selected: _unref(selectPackageIndex) === index }),
                  onClick: ($event: any) => (selectPackage(item, index)),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(item.agentPackageName), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(item.cmeFlowCount) + "GB", 1),
                        _hoisted_13
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("span", null, _toDisplayString(item.strDays), 1),
                        _hoisted_15
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, "￥" + _toDisplayString(item.agentSalePrice), 1),
                    _createElementVNode("div", _hoisted_18, "月均" + _toDisplayString(item.monthAvgPrice) + "元", 1)
                  ])
                ], 10, _hoisted_7))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, {
            title: "90天",
            name: "90"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packageList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: "packageItem",
                  class: _normalizeClass({ selected: _unref(selectPackageIndex) === index }),
                  onClick: ($event: any) => (selectPackage(item, index)),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, _toDisplayString(item.agentPackageName), 1),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("span", _hoisted_24, _toDisplayString(item.cmeFlowCount) + "GB", 1),
                        _hoisted_25
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("span", null, _toDisplayString(item.strDays), 1),
                        _hoisted_27
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, "￥" + _toDisplayString(item.agentSalePrice), 1),
                    _createElementVNode("div", _hoisted_30, "月均" + _toDisplayString(item.monthAvgPrice) + "元", 1)
                  ])
                ], 10, _hoisted_19))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, {
            title: "180天",
            name: "180"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packageList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: "packageItem",
                  class: _normalizeClass({ selected: _unref(selectPackageIndex) === index }),
                  onClick: ($event: any) => (selectPackage(item, index)),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_32, [
                    _createElementVNode("div", _hoisted_33, _toDisplayString(item.agentPackageName), 1),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("span", _hoisted_36, _toDisplayString(item.cmeFlowCount) + "GB", 1),
                        _hoisted_37
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("span", null, _toDisplayString(item.strDays), 1),
                        _hoisted_39
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, "￥" + _toDisplayString(item.agentSalePrice), 1),
                    _createElementVNode("div", _hoisted_42, "月均" + _toDisplayString(item.monthAvgPrice) + "元", 1)
                  ])
                ], 10, _hoisted_31))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, {
            title: "360天",
            name: "360"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packageList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: "packageItem",
                  class: _normalizeClass({ selected: _unref(selectPackageIndex) === index }),
                  onClick: ($event: any) => (selectPackage(item, index)),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_44, [
                    _createElementVNode("div", _hoisted_45, _toDisplayString(item.agentPackageName), 1),
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("span", _hoisted_48, _toDisplayString(item.cmeFlowCount) + "GB", 1),
                        _hoisted_49
                      ]),
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("span", null, _toDisplayString(item.strDays), 1),
                        _hoisted_51
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, "￥" + _toDisplayString(item.agentSalePrice), 1),
                    _createElementVNode("div", _hoisted_54, "月均" + _toDisplayString(item.monthAvgPrice) + "元", 1)
                  ])
                ], 10, _hoisted_43))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, {
            title: "720天",
            name: "720"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packageList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: "packageItem",
                  class: _normalizeClass({ selected: _unref(selectPackageIndex) === index }),
                  onClick: ($event: any) => (selectPackage(item, index)),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_56, [
                    _createElementVNode("div", _hoisted_57, _toDisplayString(item.agentPackageName), 1),
                    _createElementVNode("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _createElementVNode("span", _hoisted_60, _toDisplayString(item.cmeFlowCount) + "GB", 1),
                        _hoisted_61
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("span", null, _toDisplayString(item.strDays), 1),
                        _hoisted_63
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, "￥" + _toDisplayString(item.agentSalePrice), 1),
                    _createElementVNode("div", _hoisted_66, "月均" + _toDisplayString(item.monthAvgPrice) + "元", 1)
                  ])
                ], 10, _hoisted_55))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_van_tab, {
            title: "加餐包",
            name: "0"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(packageList), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  id: "packageItem",
                  class: _normalizeClass({ selected: _unref(selectPackageIndex) === index }),
                  onClick: ($event: any) => (selectPackage(item, index)),
                  key: index
                }, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("div", _hoisted_69, _toDisplayString(item.agentPackageName), 1),
                    _createElementVNode("div", _hoisted_70, [
                      _createElementVNode("div", _hoisted_71, [
                        _createElementVNode("span", _hoisted_72, _toDisplayString(item.cmeFlowCount) + "GB", 1),
                        _hoisted_73
                      ]),
                      _createElementVNode("div", _hoisted_74, [
                        _createElementVNode("span", null, _toDisplayString(item.strDays), 1),
                        _hoisted_75
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, "￥" + _toDisplayString(item.agentSalePrice), 1),
                    _createElementVNode("div", _hoisted_78, "月均" + _toDisplayString(item.monthAvgPrice) + "元", 1)
                  ])
                ], 10, _hoisted_67))
              }), 128))
            ]),
            _: 1
          }),
          _createElementVNode("div", {
            class: "purchaseNotes",
            onClick: toPurchaseNotes,
            style: {"margin-top":"20px"}
          }, " 购买须知 "),
          (!_unref(packageList)?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_79, _hoisted_82))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["active"])
    ]),
    _createVNode(_component_van_button, {
      color: "#FF7744",
      block: "",
      onClick: toPurchase,
      class: "toPurchase"
    }, {
      default: _withCtx(() => [
        _createTextVNode("立即购买")
      ]),
      _: 1
    }),
    _createVNode(_component_van_popup, {
      show: _unref(purchaseShow),
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (_isRef(purchaseShow) ? (purchaseShow).value = $event : purchaseShow = $event)),
      round: "",
      style: { padding: '30px', height: '350px', width: '85%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_83, [
          _hoisted_84,
          _createElementVNode("div", _hoisted_85, "卡号：" + _toDisplayString(_unref(carInfo).phone), 1),
          _createElementVNode("div", _hoisted_86, "ICCID：" + _toDisplayString(_unref(carInfo).iccid), 1),
          _createElementVNode("div", _hoisted_87, " 购买套餐：" + _toDisplayString(_unref(selectPackageItem)?.agentPackageName), 1),
          _createElementVNode("div", _hoisted_88, " 支付金额：" + _toDisplayString(_unref(selectPackageItem)?.agentSalePrice), 1),
          _createVNode(_component_van_button, {
            color: "#F9DA4E",
            block: "",
            style: {"margin":"10px 0","color":"black"},
            onClick: submitOrder
          }, {
            default: _withCtx(() => [
              _createTextVNode("提交订单")
            ]),
            _: 1
          }),
          _createVNode(_component_van_button, {
            color: "#DCDEE0",
            block: "",
            onClick: cancelOrder
          }, {
            default: _withCtx(() => [
              _createTextVNode("我再想想")
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(againPurchaseShow),
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(againPurchaseShow) ? (againPurchaseShow).value = $event : againPurchaseShow = $event)),
      round: "",
      style: { padding: '30px', height: '200px', width: '85%' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_89, [
          _hoisted_90,
          _createElementVNode("div", null, "您有一笔未支付订单：" + _toDisplayString(_unref(againPackageName)) + "！", 1),
          _createElementVNode("div", _hoisted_91, [
            _createVNode(_component_van_button, {
              color: "#DCDEE0",
              block: "",
              onClick: againCancelOrder
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭订单")
              ]),
              _: 1
            }),
            _createVNode(_component_van_button, {
              color: "#F9DA4E",
              block: "",
              style: {"color":"black"},
              onClick: againSubmitOrder
            }, {
              default: _withCtx(() => [
                _createTextVNode("再次支付")
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})